import React from "react";
import { useDimensions } from "../../Util";
import ActCard from "./ActCard";

const ActsContainer=({actsData})=>{

    const { w, h } = useDimensions();

    const actsContainer = {
        gridRow: w > h ? "17 / 51" : "28/51",
        gridColumn: w > h ? "12 / 51" : "1/51",
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "center",
        flexWrap:"wrap",
        overflowY:"scroll",
        overflowX:"hidden",
        gap:"7px",
        scrollbarColor: "#00ADB5 #222831",
        scrollbarWidth: "thin",
        boxSizing: "border-box",
    }
    return <div style={actsContainer}>
        {actsData.map((card, index) => (
            <ActCard
                key={index}
                id={card.id}
                image={card.image}
                text={card.text}
                type={card.type}
                value={card.value}
            />
        ))}
        
    </div>
}

export default ActsContainer;